import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LoginPage from "@/pages/LoginPage";
import DuckRiceApp from "@/pages/DuckRiceApp";
import GiftClaimPage from "@/pages/GiftClaimPage";
import { Toaster } from "sonner";
import "@/App.css";

// Set the duck-mask URL on :root so CSS .duck-logo can reference it.
// Using process.env.PUBLIC_URL avoids CRA css-loader trying to resolve a public path.
if (typeof document !== "undefined") {
  document.documentElement.style.setProperty(
    "--duck-mask",
    `url("${process.env.PUBLIC_URL || ""}/brand/duck-symbol.png")`
  );
}

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div data-testid="auth-loading" style={{ height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FCF9E8", fontFamily: "'LatinCTSemiCond', 'Fraunces', Georgia, serif", letterSpacing: "0.3em", fontSize: 12 }}>
        OPENING THE DOOR…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
          <Route path="/gift/:code" element={<GiftClaimPage />} />
          <Route path="/" element={<ProtectedRoute><DuckRiceApp /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
